import { type PreviewSelectionActionEvent } from '../events/types';
import { type SelectionState } from '../state/types';

import { type ReducerResponse } from './types';

/**
 * Reducer for preview selection action events.
 * Does not modify state - emits a delta so effects can respond to preview intents.
 */
export function previewSelectionActionReducer(
  state: SelectionState,
  event: PreviewSelectionActionEvent
): ReducerResponse {
  return {
    next: state,
    delta: {
      kind: 'previewSelectionAction',
      source: event.source,
      intent: event.intent
    }
  };
}
